import { ApiRequestError } from "../../../api/util";
import { useRevokeDelegation } from "../../../hooks/delegation/useRevokeDelegation";
import { Button } from "../../Button";
import Spinner from "../../graphics/Spinner";
import Modal, { ModalRoot } from "../../Modal/Modal";

interface RevokeDelegationModalProps {
  delegationId: string | null;
  onDelegationIdChange: (delegationId: string | null) => void;
  onError: (message: string) => void;
}

const RevokeDelegationModal = ({
  delegationId,
  onDelegationIdChange,
  onError,
}: RevokeDelegationModalProps) => {
  const revokeMutation = useRevokeDelegation();
  const isOpen = delegationId !== null;
  const isPending = revokeMutation.isPending;

  const handleOpenChange = (open: boolean) => {
    if (!open && !isPending) onDelegationIdChange(null);
  };

  const handleRevoke = async () => {
    if (!delegationId) return;

    try {
      await revokeMutation.mutateAsync(delegationId);
      onDelegationIdChange(null);
    } catch (err) {
      onError(
        err instanceof ApiRequestError
          ? err.message
          : "Kunne ikke tilbagekalde fuldmagten.",
      );
    }
  };

  return (
    <ModalRoot
      controller={{
        open: isOpen,
        setOpen: handleOpenChange,
      }}
    >
      <Modal
        small
        title="Tilbagekald fuldmagt"
        description="Bekræft tilbagekaldelse af fuldmagt"
        footer={
          <div className="d-flex justify-content-end gap-2 p-4">
            <button
              type="button"
              className="btn btn-outline"
              onClick={() => onDelegationIdChange(null)}
              disabled={isPending}
            >
              Annuller
            </button>
            <Button
              id="delegation-revoke-confirm"
              color="primary"
              onClick={handleRevoke}
              disabled={isPending}
            >
              {isPending ? (
                <span className="d-inline-flex align-items-center gap-2">
                  <Spinner inline size={16} label="" />
                  Tilbagekalder...
                </span>
              ) : (
                "Tilbagekald"
              )}
            </Button>
          </div>
        }
      >
        <p className="mb-0">
          Er du sikker på, at du vil tilbagekalde denne fuldmagt? Personen kan
          herefter ikke længere logge ind på dine vegne.
        </p>
      </Modal>
    </ModalRoot>
  );
};

export default RevokeDelegationModal;
